import React, { useEffect, useState } from "react"
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Label,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { UFDate } from "../../../components/Common/Fields/Input"
import moment from "moment"
import { filter, isEmpty } from "lodash"
import { useForm } from "react-hook-form"
import {
  downloadTrialBalance,
  fetchFinanceTrialBalance,
} from "../../../services/finance/finance"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Logo from "../../../assets/images/logo.svg"
import { useLocation, useNavigate } from "react-router-dom"
import arrow from "../../../assets/icons/arrow.svg"
import resetIcon from "../../../assets/icons/reset.svg"
import NumberFormat from "../../../utils/numberFormat"
import { createSelector } from "reselect"
import { useSelector, useDispatch } from "react-redux"
import NestedAccordion from "../../../components/Common/AccordionTable"
import { setFilter, removeFilter } from "../../../store/actions"
import WordSymbolDisplay from "../../../components/Common/LoadingAnim"

const TrialBalance = ({ fromDashboard }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Trial Balance${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`
  const dispatch = useDispatch()
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [fetchedData, setFetchedData] = useState()
  const [fetchedDataFilter, setFetchedDataFilter] = useState()
  const [debitTotal, setDebitTotal] = useState(0)
  const [creditTotal, setCreditTotal] = useState(0)
  const [refresh, setRefresh] = useState(0)

  const [accordionOpen, setAccordionOpen] = useState("")

  const [openMap, setOpenMap] = useState({})

  const [detailedCheck, setDetailedCheck] = useState(false)
  const [detailedCheckIds, setDetailedCheckIds] = useState([])

  const [rSelected, setRSelected] = useState(1)

  // handler receives (sourceKey, openIdsArray)
  // NestedAccordion will call this as (parentKey, openArray)
  const handleOpenChange = (sourceKey, openIdsArray) => {
    console.log(`openIdsArray`, openIdsArray)

    // store the array under the sourceKey so we can aggregate later
    setOpenMap(prev => ({ ...prev, [sourceKey]: openIdsArray || [] }))
  }

  // keep accordionOpen as a flattened unique array of open data ids
  useEffect(() => {
    const all = [...new Set(Object.values(openMap).flat())]
    setAccordionOpen(all)
  }, [openMap])

  console.log(`accordionOpen`, accordionOpen, openMap)

  const [isLoading, setIsLoading] = useState(true)

  const locations = useLocation()
  const crumb = locations?.state?.menuLabel || ""

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const selectFilterState = state => state.filterReducer
  const filterProperties = createSelector(selectFilterState, filter => ({
    filters: filter.filters,
    filterLoading: filter.loading,
    filterError: filter.error,
  }))

  const { filters, filterLoading, filterError } = useSelector(filterProperties)

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const { control, watch, reset, setValue } = useForm()

  const navigate = useNavigate()

  useEffect(() => {
    if (filters?.dateFrom || filters?.dateTo) {
      setValue(
        "start_date",
        filters?.dateFrom
          ? moment(filters?.dateFrom, "YYYY-MM-DD").toDate()
          : null,
        { shouldValidate: false, shouldDirty: false }
      )
      setValue(
        "end_date",
        filters?.dateTo ? moment(filters?.dateTo, "YYYY-MM-DD").toDate() : null,
        { shouldValidate: false, shouldDirty: false }
      )
      const fetchData = async () => {
        setIsLoading(true)
        const responce = await fetchFinanceTrialBalance({
          params: `${
            filters?.dateFrom ? `&start_date=${filters?.dateFrom}` : ""
          }${`&sortOrder=asc`}${
            filters?.dateTo ? `&end_date=${filters?.dateTo}` : ""
          }`,
        })
        setFetchedData(responce)
        setIsLoading(false)
      }
      fetchData()
    }
  }, [filters?.dateFrom, filters?.dateTo])

  useEffect(() => {
    if (filters?.dateFrom || filters?.dateTo) return
    const fetchData = async () => {
      setIsLoading(true)
      const responce = await fetchFinanceTrialBalance({
        params: `${
          startDate ? `&start_date=${startDate}` : ""
        }${`&sortOrder=asc`}${endDate ? `&end_date=${endDate}` : ""}`,
      })
      setFetchedData(responce)
      setIsLoading(false)
    }
    fetchData()
  }, [startDate, endDate, refresh])

  const filterNonZeroEntries = entries =>
    entries?.filter(
      entry =>
        (Number(entry.debit) ?? 0) !== 0 || (Number(entry.credit) ?? 0) !== 0
    )

  useEffect(() => {
    const filteredData = {
      asset: filterNonZeroEntries(fetchedData?.data.asset),
      expense: filterNonZeroEntries(fetchedData?.data.expense),
      income: filterNonZeroEntries(fetchedData?.data.income),
      liability: filterNonZeroEntries(fetchedData?.data.liability),
    }
    setFetchedDataFilter(filteredData)
  }, [fetchedData])

  useEffect(() => {
    if (fetchedData) {
      let totalDebit = 0
      let totalCredit = 0

      // Object.keys(fetchedData?.data).forEach(key => {
      // const { debitSide, creditSide } = getTotalDifference(
      //   fetchedData.data[key]
      // )
      let debitSide = fetchedData?.total_debit
      let creditSide = fetchedData?.total_credit
      totalDebit += debitSide
      totalCredit += creditSide
      // })
      console.log("totalcredt:", totalCredit)
      const opBal = fetchedData?.opening_balance_difference
      console.log("opBal:", opBal)

      const debitTotalWithOP =
        fetchedData?.opening_balance_type == "debit"
          ? Math.abs(Number(totalDebit)) + Math.abs(Number(opBal))
          : Math.abs(Number(totalDebit))
      const creditTotalWithOP =
        fetchedData?.opening_balance_type == "credit"
          ? Math.abs(Number(totalCredit)) + Math.abs(Number(opBal))
          : Math.abs(Number(totalCredit))

      setDebitTotal(debitTotalWithOP)
      setCreditTotal(creditTotalWithOP)

      console.log("debitTotalWithOP:", debitTotalWithOP)
      console.log("creditTotalWithOP:", creditTotalWithOP)
    }
  }, [fetchedData])

  const handleReset = () => {
    reset()
    setStartDate("")
    setEndDate("")
    setRefresh(refresh + 1)
    dispatch(removeFilter())
  }

  const getAllGroupIds = data => {
    const ids = []

    const extractIds = arr => {
      arr?.forEach(item => {
        if (item?.id) ids.push(item.id)
        if (item?.sub_groups?.length) extractIds(item.sub_groups)
      })
    }

    // Loop top-level categories like asset, liability, income, expense...
    Object.values(data).forEach(section => {
      if (Array.isArray(section)) extractIds(section)
    })

    return ids
  }

  const handleDetailedCheck = check => {
    setDetailedCheck(!check)
    if (!check == true) {
      const allIds = getAllGroupIds(fetchedData?.data)
      console.log("allIds", allIds)
      setDetailedCheckIds(allIds)
    } else {
      setDetailedCheckIds([])
    }
  }

  useEffect(() => {
    if (rSelected === 2) {
      const allIds = getAllGroupIds(fetchedData?.data)
      console.log("allIds", allIds)
      setDetailedCheckIds(allIds)
    } else {
      setDetailedCheckIds([])
    }
  }, [rSelected])

  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              {!fromDashboard ? (
                <>
                  <Breadcrumbs
                    title="Finance"
                    breadcrumbObject={[
                      { title: "Finance", link: "/finance" },
                      { title: crumb || "Reports", link: "#" },
                      {
                        title: "Trial Balance",
                        link: "/finance-trial-balance",
                      },
                    ]}
                  />
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="pe-2 d-flex align-items-center">
              {fetchedData?.data ? (
                <>
                  <ButtonGroup className="mb-auto">
                    <Button
                      color="primary px-2 m-0"
                      outline
                      onClick={() => {
                        setRSelected(1)
                        // setAgeingPeriod([])
                      }}
                      active={rSelected === 1}
                    >
                      Default
                    </Button>
                    <Button
                      color="primary px-2 m-0"
                      outline
                      onClick={() => {
                        // setAgeingPeriod([])
                        setRSelected(2)
                      }}
                      active={rSelected === 2}
                    >
                      Detailed
                    </Button>
                  </ButtonGroup>
                  {/* <input
                    type="checkbox"
                    className="ever-rise-checkbox"
                    name={"is_aging"}
                    checked={detailedCheck}
                    onClick={() => handleDetailedCheck(detailedCheck)}
                  />
                  <Label className="ms-2 mb-0">Detailed</Label> */}
                </>
              ) : (
                <></>
              )}
              <div
                className="export-div pointer reset-img me-2 py-2"
                onClick={() => handleReset()}
              >
                <img src={resetIcon} height={15} width={15} className="" />{" "}
              </div>
              <div className="me-2">
                <UFDate
                  control={control}
                  name="start_date"
                  placeholder="Start Date"
                  mode="single"
                  onDateChange={([date]) =>
                    setStartDate(date ? moment(date).format("YYYY-MM-DD") : "")
                  }
                  maxDate={endDate || undefined}
                  readOnly={false}
                  widthClass="w-100"
                />
              </div>
              {/* End Date */}
              <div className="me-2">
                <UFDate
                  control={control}
                  name="end_date"
                  placeholder="End Date"
                  mode="single"
                  onDateChange={([date]) =>
                    setEndDate(date ? moment(date).format("YYYY-MM-DD") : "")
                  }
                  minDate={startDate || undefined}
                  readOnly={false}
                  widthClass="w-100"
                />
              </div>
              <>
                <div className="me-2">
                  <span id={`PopoverLegacy-1`} className="px-2 btn btn-primary">
                    Download
                  </span>
                </div>
                <UncontrolledPopover
                  placement="bottom"
                  target={`PopoverLegacy-1`}
                  trigger="legacy"
                >
                  <PopoverBody>
                    <div
                      className="table-popup-content"
                      onClick={() =>
                        downloadTrialBalance({
                          params: `pdf=true${
                            startDate ? `&start_date=${startDate}` : ""
                          }${endDate ? `&end_date=${endDate}` : ""}${
                            rSelected === 2
                              ? `&show_paths=${detailedCheckIds}`
                              : accordionOpen?.length
                              ? `&show_paths=${accordionOpen}`
                              : ""
                          }`,
                          type: "pdf",
                          fileName: "trial_balance.pdf",
                        })
                      }
                    >
                      PDF
                    </div>
                    <div
                      className="table-popup-content"
                      onClick={() =>
                        downloadTrialBalance({
                          params: `excel=true${
                            startDate ? `&start_date=${startDate}` : ""
                          }${endDate ? `&end_date=${endDate}` : ""}${
                            rSelected === 2
                              ? `&show_paths=${detailedCheckIds}`
                              : accordionOpen?.length
                              ? `&show_paths=${accordionOpen}`
                              : ""
                          }`,
                          type: "excel",
                          fileName: "trial_balance.xlsx",
                        })
                      }
                    >
                      Excel
                    </div>
                    <div
                      className="table-popup-content"
                      onClick={() =>
                        downloadTrialBalance({
                          params: `pdf=true${
                            startDate ? `&start_date=${startDate}` : ""
                          }${endDate ? `&end_date=${endDate}` : ""}${
                            detailedCheck
                              ? `&show_paths=${detailedCheckIds}`
                              : accordionOpen?.length
                              ? `&show_paths=${accordionOpen}`
                              : ""
                          }`,
                          type: "print",
                          fileName: "trial_balance.pdf",
                        })
                      }
                    >
                      Preview
                    </div>
                  </PopoverBody>
                </UncontrolledPopover>
              </>
            </div>
          </div>
          <Card
            className={`me-2 px-2 pb-2 ${
              fromDashboard ? "dash-table-bg ps-0 pb-0 finance-table-nav" : ""
            }`}
          >
            {isLoading ? (
              <WordSymbolDisplay />
            ) : (
              <>
                <div className="d-flex justify-content-between align-items-center mt-2 py-2 px-2">
                  <img className="view-logo" src={Logo} alt="logo" />

                  <div className="payroll-total edittheamtitle">
                    Trial Balance
                  </div>
                  <div className="fs-14">
                    {startDate && endDate
                      ? `${moment(startDate).format("DD-MMM-YYYY")} -
                    ${moment(endDate).format("DD-MMM-YYYY")}`
                      : `As of ${moment().format("DD-MMM-YYYY")}`}
                  </div>
                </div>
                <hr className="table-divide" />
                <table className="estimation-table">
                  <thead>
                    <tr>
                      <th className="w-50">Account Name</th>
                      <th className="w-25 text-end pe-5">Debit (AED)</th>
                      <th className="w-25 text-end pe-5">Credit (AED)</th>
                    </tr>
                  </thead>
                </table>
                <div className="trial-scroll">
                  {fetchedDataFilter?.asset?.length ? (
                    <div className="ps-4 pb-3 dotted-border-y">
                      <div className="d-flex justify-content-between">
                        <div className="mapping-setup-title py-2 text-capitalize edittheamtitle">
                          Assets
                        </div>
                      </div>
                      <div className="ms-2">
                        <Row className="mt-2 ever-rise-table reportTable trial-table">
                          <Col xs={12}>
                            {fetchedDataFilter?.asset && (
                              <NestedAccordion
                                parentKey="asset"
                                data={fetchedDataFilter?.asset}
                                startDate={startDate}
                                endDate={endDate}
                                menuLabels="Trial Balance"
                                onOpenChange={handleOpenChange}
                                forceOpenAll={rSelected === 2}
                              />
                            )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  {fetchedDataFilter?.liability?.length ? (
                    <div className="ps-4 py-3 dotted-border-y">
                      <div className="d-flex justify-content-between">
                        <div className="mapping-setup-title py-2 text-capitalize edittheamtitle">
                          Liability
                        </div>
                      </div>
                      <div className="ms-2">
                        <Row className="mt-2 ever-rise-table reportTable trial-table ">
                          <Col xs={12}>
                            {fetchedDataFilter?.liability && (
                              <NestedAccordion
                                parentKey="liability"
                                data={fetchedDataFilter?.liability}
                                startDate={startDate}
                                endDate={endDate}
                                menuLabels="Trial Balance"
                                onOpenChange={handleOpenChange}
                                forceOpenAll={rSelected === 2}
                              />
                            )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  {fetchedDataFilter?.income?.length ? (
                    <div className="ps-4 py-3 dotted-border-y">
                      <div className="d-flex justify-content-between">
                        <div className="mapping-setup-title py-2 text-capitalize edittheamtitle">
                          Income
                        </div>
                      </div>
                      <div className="ms-2">
                        <Row className="mt-2 ever-rise-table reportTable trial-table ">
                          <Col xs={12}>
                            {fetchedDataFilter?.income && (
                              <NestedAccordion
                                parentKey="income"
                                data={fetchedDataFilter?.income}
                                startDate={startDate}
                                endDate={endDate}
                                menuLabels="Trial Balance"
                                // onOpenChange={openId => {
                                //   console.log("Accordion open id:", openId)
                                //   setAccordionOpen(openId)
                                // }}
                                onOpenChange={handleOpenChange}
                                forceOpenAll={rSelected === 2}
                              />
                            )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  {fetchedDataFilter?.expense?.length ? (
                    <div className="ps-4 py-3">
                      <div className="d-flex justify-content-between">
                        <div className="mapping-setup-title py-2 text-capitalize edittheamtitle">
                          Expense
                        </div>
                      </div>
                      <div className="ms-2">
                        <Row className="mt-2 ever-rise-table reportTable trial-table ">
                          <Col xs={12}>
                            {fetchedDataFilter?.expense && (
                              <NestedAccordion
                                parentKey="expense"
                                data={fetchedDataFilter?.expense}
                                startDate={startDate}
                                endDate={endDate}
                                menuLabels="Trial Balance"
                                onOpenChange={handleOpenChange}
                                forceOpenAll={rSelected === 2}
                              />
                            )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  {!fetchedDataFilter?.asset?.length &&
                  !fetchedDataFilter?.liability?.length &&
                  !fetchedDataFilter?.income?.length &&
                  !fetchedDataFilter?.expense?.length ? (
                    <div className="d-flex justify-content-center mt-2">
                      No data available
                    </div>
                  ) : (
                    <table className="estimation-table trial-balance-total">
                      <thead>
                        {fetchedData?.opening_balance_difference != 0 ? (
                          <tr className="">
                            <th className="w-50 py-2">
                              Opening Balance Difference
                            </th>
                            <th className="w-25 ps-3 text-end pe-5 py-2">
                              {NumberFormat(
                                Math.abs(
                                  Number(
                                    fetchedData?.opening_balance_type == "debit"
                                      ? fetchedData?.opening_balance_difference
                                      : 0
                                  )
                                ),
                                desimalrange,
                                desimalrange
                              )}
                            </th>
                            <th className="w-25 ps-3 text-end pe-5 py-2">
                              {NumberFormat(
                                Math.abs(
                                  Number(
                                    fetchedData?.opening_balance_type ==
                                      "credit"
                                      ? fetchedData?.opening_balance_difference
                                      : 0
                                  )
                                ),
                                desimalrange,
                                desimalrange
                              )}
                            </th>
                          </tr>
                        ) : (
                          <></>
                        )}
                        <tr>
                          <th className="w-50">Total</th>
                          <th className="w-25 ps-3 text-end pe-5">
                            {NumberFormat(
                              Number(debitTotal ? debitTotal : 0),
                              desimalrange,
                              desimalrange
                            )}
                          </th>
                          <th className="w-25 ps-3 text-end pe-5">
                            {NumberFormat(
                              Number(creditTotal ? creditTotal : 0),
                              desimalrange,
                              desimalrange
                            )}
                          </th>
                        </tr>
                      </thead>
                    </table>
                  )}
                </div>
              </>
            )}
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default TrialBalance
